// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d683a48","453":"96a028a9","732":"a13dcb42"}[chunkId] + ".chunk.js";
};